import { render, staticRenderFns } from "./postdoctorMonograph.vue?vue&type=template&id=2a9cd650&scoped=true&"
import script from "./postdoctorMonograph.vue?vue&type=script&lang=js&"
export * from "./postdoctorMonograph.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorMonograph.vue?vue&type=style&index=0&id=2a9cd650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9cd650",
  null
  
)

export default component.exports